import { createContext } from "react";

export type PwaInstallOutcome = "accepted" | "dismissed" | "error" | "unavailable";

export interface PwaInstallContextValue {
  canInstall: boolean;
  dismiss: (surface: string) => void;
  prompt: (surface: string) => Promise<PwaInstallOutcome>;
}

export const PwaInstallContext = createContext<PwaInstallContextValue | null>(null);
